import Response from '../response';

class ResponseError<T = any> extends Response {
  public readonly error: T;
  public readonly data;

  // @ts-ignore
  constructor(error) {
    super(null);

    this.error = error;

    this.data = null;

    this.isFailure = true;
    this.isSuccess = false;
  }
}

export default ResponseError;
